import CciPageSlide from './slide/CciPageSlide.vue'
import { mapGetters } from 'vuex'
import Swiper from 'swiper/bundle'
import { CciDataSourceUpdatePages, CciDataSourceClearMemory, CciDataSourceCreateDummyPage, pages } from 'model/CciDataSource.js'

export default {
  data () {
    return {
      swiper: null,
      pageContainerSize: {},
      swipeCounter: 1,
      // didSwipePage: false,
      // loadSwiperWithPpageIndex: -1,
      // isInterstitialInserted: false,
      // isShowingInterstitial: false,
      // adSlot: null,
      // shouldDisplayAd: true,
      // pagesLoaded: [],
      pageSlideVirtualData: {
        slides: []
      },
      resizeObserver: null,
      isZoomed: false
    }
  },
  created () {
    // window.addEventListener('resize', this.didResize)
    window.addEventListener("orientationchange", this.orientationDidChange)

    document.addEventListener('fullscreenchange', this.fullscreenChange, false)
    document.addEventListener('mozfullscreenchange', this.fullscreenChange, false)
    document.addEventListener('webkitfullscreenchange', this.fullscreenChange, false)
    document.addEventListener('msfullscreenchange', this.fullscreenChange, false)

    document.addEventListener('keydown', this.checkKeyDown)

    window.addEventListener('prepareInterstitialAd', this.insertInterstitialAdPlaceholder, false)
  },
  mounted () {
    // this.applySettings(this.settings)
    this.setPagesContainerLayout()
    if (this.swiper === null) {
      // This is only necessary when returning to pages from article list.
      // In other cases we initialize the swiper when pages are loaded.
      // Then why don't why always only initialize the swiper here?
      // When the app is loaded for the first time we have to initialize it again when the pages are loaded, because the pages is not ready to be layouted.
      this.updateSizeOfPagesContainer()
      if (this.pages.length > 0) {
        this.initializeSwiper()
      }
      var pageNumber = this.$route.params.pageNr
      var pageIndex = this.getPageIndexFromRouteParam(pageNumber)
      // this.cleanAndResetInterstitials()
      if (this.pages !== undefined && this.pages[pageIndex] !== undefined) {
        var page = this.pages[pageIndex]
        this.$cciEventTrackingPlugin.trackEvent('ContextPageView', 'ActionPagesPageView', page.firstPage, page.firstPage.attributes.Page)
        if (!page.firstPage.isInterstitialAdPlaceholder) {
          this.wantInterstitialAd(page)
        }
        if (page.secondPage !== null) {
          this.$cciEventTrackingPlugin.trackEvent('ContextPageView', 'ActionPagesPageView', page.secondPage, page.secondPage.attributes.Page)
        }
        this.setCurrentSectionFromPage(page)
      }

      this.resizeObserver = new ResizeObserver(this.didResize)
      this.resizeObserver.observe(this.$refs['pages-container'])
    }
  },
  computed: {
    isIE11: function () {
      return !!window.MSInputMethodContext && !!document.documentMode
    },
    totalNumberOfPages: function () {
      if (this.pages[0] !== undefined) {
        if (this.pages[this.pages.length - 1].secondPage !== null) {
          return this.pages[this.pages.length - 1].secondPage.pageNumber
        }
        return this.pages[this.pages.length - 1].firstPage.pageNumber
      }
      return 0
    },
    currentPageNumber: function () {
      if (this.currentPage !== undefined) {
        var firstNumber = this.currentPage.firstPage.pageNumber
        if (this.currentPage.secondPage !== null) {
          var secondNumber = this.currentPage.secondPage.pageNumber
          return firstNumber + '-' + secondNumber
        }
        return firstNumber
      }
    },
    showPrevButton () {
      if (this.swiper !== null) {
        return this.getPageIndexFromActiveSlideIndex() > 0 && !(this.isZoomed && (this.isPhone() || this.isTablet()))
      }
    },
    showNextButton () {
      if (this.swiper !== null) {
        return this.getPageIndexFromActiveSlideIndex() < this.pages.length - 1 && !(this.isZoomed && (this.isPhone() || this.isTablet()))
      }
    },
    showLeftScrubberButton () {
      // this.isZoomed = this.zoomedPages.indexOf(this.currentPage) !== -1
      return (this.isPhone() || this.isTabletPortrait()) && this.settings !== undefined && this.settings.enableVerticalLayout && !this.isZoomed
    },
    ...mapGetters({
      currentSection: 'getCurrentSection',
      currentArticle: 'getCurrentArticle',
      pages: 'getPages',
      sections: 'getSections',
      currentPage: 'getCurrentPage',
      // pageFromSection: 'getPageFromSection',
      transitionToPage: 'getTransitionToPage',
      showScrubber: 'getShowScrubber',
      showIssueOverview: 'getShowIssueOverview',
      showArticleModal: 'getShowArticleModal',
      showImageGalleryModal: 'getShowImageGalleryModal',
      settings: 'getSettings',
      interstitialsFrequency: 'getInterstitialsFrequency',
      interstitials: 'getInterstitials',
      // resetInterstitials: 'getResetInterstitials',
      adsEnabled: 'getAdsEnabled',
      singlePagesNoAds: 'getSinglePagesNoAds',
      isFullPageViewMode: 'getPageViewMode',
      zoomedPages: 'getZoomedPages',
      opsUrl: 'getOpsUrl',
      slidesPageIndexes: 'getSlidesPageIndexes'
    })
  },
  watch: {
    settings: function() {
      // this.applySettings(newValue)
      this.setPagesContainerLayout()
    },
    currentPage: function (newValue) {
      // This happens for every page change. Except when navigating from article list!.
      if (newValue.firstPage.interstitialInfo) {
        this.$cciEventTrackingPlugin.trackEvent('ContextPageView', 'ActionPagesInterstitialPageView', newValue.firstPage)
      } else if (!newValue.firstPage.isInterstitialAdPlaceholder) {
        this.$cciEventTrackingPlugin.trackEvent('ContextPageView', 'ActionPagesPageView', newValue.firstPage, newValue.firstPage.attributes.Page)
        if (newValue.secondPage !== null) {
          this.$cciEventTrackingPlugin.trackEvent('ContextPageView', 'ActionPagesPageView', newValue.secondPage, newValue.secondPage.attributes.Page)
        }
      }

      if (!newValue.firstPage.isInterstitialAdPlaceholder) {
        this.wantInterstitialAd(newValue)
      }

      if (this.interstitials !== undefined) {
        if (!newValue.firstPage.isInterstitial) {
          this.swipeCounter === this.interstitialsFrequency ? this.insertInterstitials() : this.cleanUpInterstitialsAndUpdate() 
        }
      }

      // this.didSwipePage = false

      this.updateSectionBarFromPage(newValue)

      if (this.$store.state.startArticleId != undefined) {
        this.$store.commit('setCurrentArticleFromIds', {'articleId': this.$store.state.startArticleId, 'pageId': undefined})
        this.$store.commit('setSelectedPageChild', this.currentArticle)
        this.$store.commit('setShowArticleModal', true)
        this.$store.state.startArticleId = undefined
      }

      // shouldDisplayAd is only relevant on mobile devices where the layout messes up if the first page is not swiped back and forth on load.
      // if (newValue.firstPage.interstitialAdAfterPage !== undefined && this.shouldDisplayAd) {
      //   this.displayInterstitialAd()
      // } else {
      //   this.shouldDisplayAd = true
      // }
    },
    pages: function (newValue, oldValue) {
      if (this.swiper === null) {
        this.initializeSwiper()
        this.updateSizeOfPagesContainer()
        return
      }
  
      if (oldValue.length === 0) {
        // Init
        // this.initializeSwiper()
        this.updateSizeOfPagesContainer()
      } else {
        // update current page... 
        // Why update with current page with this.currentPage? 
        // If the pages array has switched from double pages to single pages or the other way around then current page will change format when updating.
        // this.$store.commit('setCurrentPage', this.currentPage)
        this.setSlidesPageIndexes(newValue, newValue.indexOf(this.currentPage), this.swiper.activeIndex)
      }
    },
    '$route': function (to) {
      var pageNumber = to.params.pageNr
      if (this.swiper !== null) {  
        var pageIndex = this.getPageIndexFromRouteParam(pageNumber)
        if (pageIndex !== this.getPageIndexFromActiveSlideIndex()) {
          this.swiper.slideTo(this.getSlideIndexFromPageIndex(pageIndex))
        }
      }
    },
    transitionToPage (newValue) {
      this.swipeCounter = 1
      // this.didSwipePage = false

      // it is a single page - need to find matching "page pair"
      let toPage 
      for (var i = 0; i < this.pages.length; i++) {
        if (this.pages[i].firstPage.id === newValue.id || (this.pages[i].secondPage !== null && this.pages[i].secondPage.id === newValue.id)) {
          toPage = this.pages[i]
        }
      }  

      if (toPage !== this.currentPage) {
        this.swiper.slideTo(this.getSlideIndexFromPageIndex(this.pages.indexOf(toPage)))
      }
    },
    // resetInterstitials: function (newValue) {
    //   if (newValue) {
    //     this.cleanAndResetInterstitials()
    //     this.$store.commit('setResetInterstitials', false)
    //   }
    // },
    isFullPageViewMode: function (newValue, oldValue) {
      // full page change -> reload.

      if (oldValue !== newValue && oldValue !== undefined) {
        this.reloadData(newValue)
      }
    },
    showIssueOverview: function (newValue) {
      if (newValue) {
        document.removeEventListener('keydown', this.checkKeyDown)
      } else {
        document.addEventListener('keydown', this.checkKeyDown)
      }
      // if (this.currentPage.firstPage.interstitialAdAfterPage !== undefined) {
      //   if (newValue) {
      //     this.destroyInterstitialAd()
      //   } else {
      //     this.displayInterstitialAd()
      //   }
      // }
    },
    showArticleModal: function (newValue) {
      if (newValue) {
        document.removeEventListener('keydown', this.checkKeyDown)
      } else {
        document.addEventListener('keydown', this.checkKeyDown)
      }
      // if (this.currentPage.firstPage.interstitialAdAfterPage !== undefined) {
      //   if (newValue) {
      //     this.destroyInterstitialAd()
      //   } else {
      //     this.displayInterstitialAd()
      //   }
      // }
    },
    zoomedPages (newValue) {
      this.isZoomed = newValue.indexOf(this.currentPage) !== -1
    }
  },
  methods: {
    // applySettings (settings) {
    //   if (settings !== undefined) {
    //     var url = settings.pageNextArrowIconURL
    //     if (url !== '') {
    //       var icon = document.getElementById('next-page-button')
    //       icon.style.background = 'url(' + url + ')'
    //       icon.style.backgroundSize = 'cover'
    //     }
    //
    //     url = settings.pagePrevArrowIconURL
    //     if (url !== '') {
    //       var icon1 = document.getElementById('prev-page-button')
    //       icon1.style.background = 'url(' + url + ')'
    //       icon1.style.backgroundSize = 'cover'
    //     }
    //   }
    // },
    initializeSwiper () {
      if (this.swiper !== null) {
        return
      }

      var pagesContainer = document.getElementById('pages-container')
      pagesContainer.addEventListener('swipeToPrevPage', this.swipeToPrevPage)
      pagesContainer.addEventListener('swipeToNextPage', this.swipeToNextPage)

      const initialPageIndex = this.getPageIndexFromRouteParam(this.$route.params.pageNr)

      // we start at index 100
      const initialSlide = 100
      this.setSlidesPageIndexes(this.pages, initialPageIndex, initialSlide)

      var self = this
      this.swiper = new Swiper('.pages-swiper-container', {
        wrapperClass: 'pages-swiper-wrapper',
        slideClass: 'pages-swiper-slide',
        spaceBetween: 0,
        simulateTouch: false,
        allowTouchMove: false,
        initialSlide: initialSlide,
        virtual: {
          slides: self.createVirtualPageSlides(),
          renderExternal(data) {
            self.pageSlideVirtualData = data
          }
        },
        slidesPerView: 1
      })

      var pageToInit = this.pages[initialPageIndex]
      if (pageToInit !== undefined) {
        this.setRouterPage(pageToInit)
        this.$store.commit('setCurrentPage', pageToInit.firstPage)
        this.setCurrentArticleFromPage(pageToInit)
      }

      this.swiper.on('transitionEnd', () => {
        // const pageIndex = this.getPageIndexFromActiveSlideIndex()
        const page = this.getPageFromActiveSlideIndex()
        if (page === undefined) { return }

        this.$store.commit('setCurrentPage', page.firstPage)
        this.setRouterPage(page)
        this.setCurrentArticleFromPage(page)

        // if (this.didSwipePage) {
        //   if (this.interstitials !== undefined && this.swipeCounter === this.interstitialsFrequency) {
        //     this.swipeCounter = 1
        //     this.insertInterstitials()
          // } else if (!page.firstPage.isInterstitial) {
            // this.cleanUpInterstitialsAndUpdate()
            // this.setRouterPage(page)
            // this.setCurrentArticleFromPage(page)
          // } else {
            // this.$store.commit('setCurrentPage', page.firstPage)
            // this.setRouterPage(page)
            // this.setCurrentArticleFromPage(page)
          // }
          // if (this.interstitials !== undefined && this.swipeCounter === this.interstitialsFrequency && !this.isInterstitialInserted) {
          //   this.swipeCounter = 1
          //   this.insertInterstitials(pageIndex)
          //   // Insert interstitials on prev and next page.
          // } else if (this.interstitials !== undefined && this.isInterstitialInserted && page.firstPage.isInterstitial) {
          //   this.isShowingInterstitial = true
          //   this.$store.commit('setCurrentPage', page.firstPage)
          //   this.setRouterPage(page)
          //   this.setCurrentArticleFromPage(page)
          // } else if (this.interstitials !== undefined && this.isInterstitialInserted && this.isShowingInterstitial) {
          //   this.isShowingInterstitial = false
          //   this.isInterstitialInserted = false
          //   this.cleanUpInterstitialsAndUpdate()
          // } else {      
          //   this.$store.commit('setCurrentPage', page.firstPage)
          //   this.setRouterPage(page)
          //   this.setCurrentArticleFromPage(page)
          // }
        // } else {
        //   this.$store.commit('setCurrentPage', page.firstPage)
        //   this.setRouterPage(page)
        //   this.setCurrentArticleFromPage(page)
        // }

        let nextPageRef = this.getNextSlideRef()
        let prevPageRef = this.getPrevSlideRef()
        if (nextPageRef !== undefined) {
          nextPageRef.updateShouldScrollToRight(false)
        }
        if (prevPageRef !== undefined) {
          prevPageRef.updateShouldScrollToRight(true)
        }
      })
    },
    updateSectionBarFromPage (page) {
      // Do not update section bar if any of the visible pages is in the current section
      for (var i = 0; i < page.firstPage.sections.length; i++) {
        if (page.firstPage.sections[i] === this.currentSection) {
          return
        }
      }
      if (page.secondPage) {
        for (var k = 0; k < page.secondPage.sections.length; k++) {
          if (page.secondPage.sections[k] === this.currentSection) {
            return
          }
        }
      }
      
      this.setCurrentSectionFromPage(page)
    },
    setCurrentSectionFromPage (page) {
      this.$store.commit('setCurrentSection', page.firstPage.sections[0])
    },
    setRouterPage (page) {
      if (page === undefined) {
        return
      }
      let pageNumber = page.firstPage.pageNumber
      this.$router.replace({ name: 'pages', params: { pageNr: pageNumber }})
    },
    getPageIndexForPageId (pageId) {
      for (var i = 0; i < this.pages.length; i++) {
        let page = this.pages[i]
        if (page.firstPage.id === pageId) {
          return i
        } else if (page.secondPage !== null && page.secondPage.id === pageId) {
          return i
        }
      }
      return 0
    },
    getPageIndexFromRouteParam (pageParam) {
      for (var i = 0; i < this.pages.length; i++) {
        if (this.pages[i].firstPage.pageNumber === pageParam) {
          return i
        } else if (this.pages[i].secondPage !== null && this.pages[i].secondPage.pageNumber === pageParam) {
          return i
        }
      }
      return 0
    },
    isCurrentArticleOnPage (page) {
      if (page === undefined) {
        return false
      }
      if (page.firstPage.articles.indexOf(this.currentArticle) !== -1) {
        return true
      } else if (page.secondPage !== null && page.secondPage.articles.indexOf(this.currentArticle) !== -1) {
        return true
      }
      return false
    },
    setCurrentArticleFromPage (page) {
      if (page === undefined) {
        return
      }
      if (!this.isCurrentArticleOnPage(page)) {
        var article
        if (page.firstPage.articles.length > 0) {
          article = page.firstPage.articles[0]
        } else if (page.secondPage !== null && page.secondPage.articles.length > 0) {
          article = page.secondPage.articles[0]
        }

        if (article === undefined) {
          let pageIndex = this.pages.indexOf(page)
          article = this.nextArticle(pageIndex)
        }

        this.$store.commit('setCurrentArticle', article)
      }
    },
    nextArticle (pageIndex){
      for (var i = pageIndex; i < this.pages.length; i++) {
        if (this.pages[i].firstPage.articles.length > 0) {
          return this.pages[i].firstPage.articles[0]
        } else if (this.pages[i].secondPage !== null && this.pages[i].secondPage.articles.length > 0) {
          return this.pages[i].secondPage.articles[0]
        }
      }
      return this.previousArticle(pageIndex)
    },
    previousArticle (pageIndex) {
      for (var i = pageIndex; i >= 0; i--) {
        if (this.pages[i].secondPage !== null && this.pages[i].secondPage.articles.length > 0) {
          return this.pages[i].secondPage.articles[0]
        } else if (this.pages[i].firstPage.articles.length > 0) {
          return this.pages[i].firstPage.articles[0]
        }
      }
    },
    updateSizeOfPagesContainer () {
      var pageHeight = document.documentElement.clientHeight
      const pageContainer = document.getElementById('pages-container')
      if (pageContainer === undefined) {
        return
      }
      if (this.settings !== undefined && !this.settings.enableVerticalLayout) {
        if ((this.settings !== undefined && !this.settings.enableSectionsBar) || this.sections.length <= 1) {
          // No section bar.
          pageContainer.style.marginTop = '53px'
          // height of header = 50px + 3px margin from header to page + 3px margin from page to bottom of view.
          // = 56
          pageHeight = pageHeight - 56
        } else {
          pageContainer.style.marginTop = '0px'
          // height of header and section bar = 88px + 2px margin from section bar to page + 3px margin from page to bottom of view.
          // = 93
          pageHeight = pageHeight - 93
        }
      }

      if (this.isTablet() && this.adsEnabled) {
        pageHeight = pageHeight - 90
      } else if (this.adsEnabled && this.isPhonePortrait()) {
        // Make space for ad in bottom.
        pageHeight = pageHeight - 50
      }

      pageContainer.style.height = pageHeight.toString() + 'px'
      this.pageContainerSize = {width: Math.round(pageContainer.getBoundingClientRect().width), height: pageHeight}
    },
    checkKeyDown (e) {
      if (!this.showIssueOverview && !this.showArticleModal && !this.showImageGalleryModal) {
        e = e || window.event
        if (e.key == 'End') {
          this.swiper.slideTo(this.pages.length - 1)
        } else if (e.key == 'Home') {
          this.swiper.slideTo(0)
        } else if (e.key == 'ArrowLeft') {
          if (this.showPrevButton) {
            this.swipeToPrevPage()
          }
        } else if (e.key == 'ArrowRight') {
          if (this.showNextButton) {
            this.swipeToNextPage()
          }
        }
      }
    },
    didResize () {
      if (this.$route.name === 'pages') {
        this.updateSizeOfPagesContainer()
      }
    },
    reloadData (isFullPage) {
      let singlePages = []
      for (var i = 0; i < this.pages.length; i++) {
        singlePages.push(this.pages[i].firstPage)
        if (this.pages[i].secondPage !== null) {
          singlePages.push(this.pages[i].secondPage)
        }
      }

      CciDataSourceUpdatePages(singlePages, this.isSinglePages(), isFullPage)

      this.swiper.virtual.removeAllSlides()
      this.swiper = null
      this.$store.commit('setPages', pages)
      
      CciDataSourceClearMemory()      
    },
    hidePages() {
      var elements = document.getElementsByClassName('page-left')
      for (var i = 0; i < elements.length; i++) {
        elements[i].style.visibility = 'hidden'
      }
      var elements1 = document.getElementsByClassName('page-right')
      for (var j = 0; j < elements1.length; j++) {
        elements1[j].style.visibility = 'hidden'
      }
    },
    orientationDidChange () {
      this.hidePages()
      location.reload()
    },
    swipeToPrevPage () {
      const activeSlide = this.getCurrentSlideRef()
      if (activeSlide.scrollToLeft() || this.getPageIndexFromActiveSlideIndex() === 0) {
        return
      }
      if (!this.swiper.animating) {
        // this.$store.commit('setZoomScale', 1.0)

        // this.didSwipePage = true
        // if (this.getPageFromActiveSlideIndex().firstPage.isInterstitial) {
        //   this.didShowInterstitial(this.getPageFromActiveSlideIndex())
        //   this.swipeCounter = 1
        // }
        if (this.getPageFromActiveSlideIndex().firstPage.isInterstitialAdPlaceholder || this.getPageFromActiveSlideIndex().firstPage.isInterstitial) {
          this.swipeCounter = 1
        }
        this.swipeCounter++
        // if (this.pages[this.swiper.activeIndex].firstPage.interstitialAdAfterPage !== undefined) {
        //   // If the page is changing away from an interstitial ad then destroy the interstitial ad.
        //   this.destroyInterstitialAd()
        // }
        // this.swipeDirection = 'prev'
        this.swiper.slidePrev()
      }
    },
    swipeToNextPage () {
      const activeSlide = this.getCurrentSlideRef()
      if (activeSlide.scrollToRight() || this.getPageIndexFromActiveSlideIndex() === this.pages.length - 1) {
        return
      }
      if (!this.swiper.animating) {
        // this.$store.commit('setZoomScale', 1.0)
        // this.didSwipePage = true
        // if (this.getPageFromActiveSlideIndex().firstPage.isInterstitial) {
        //   this.didShowInterstitial(this.getPageFromActiveSlideIndex())
        //   this.swipeCounter = 1
        // }
        if (this.getPageFromActiveSlideIndex().firstPage.isInterstitialAdPlaceholder || this.getPageFromActiveSlideIndex().firstPage.isInterstitial) {
          this.swipeCounter = 1
        }
        this.swipeCounter++
        // if (this.pages[this.swiper.activeIndex].firstPage.interstitialAdAfterPage !== undefined) {
        //   // If the page is changing away from an interstitial ad then destroy the interstitial ad.
        //   this.destroyInterstitialAd()
        // }
        // this.swipeDirection = 'next'
        this.swiper.slideNext()
      }
    },
    getArticleInCenter () {
      const activeSlide = this.getCurrentSlideRef()
      return activeSlide.getArticleInCenter()
    },
    getZoomScale () {
      const activeSlide = this.getCurrentSlideRef()
      if (activeSlide.zoomer === null) {
        return 1.0
      }
      return activeSlide.zoomer.scale
    },
    getCurrentSlideRef () {
      // let currentPageId = this.swiper.virtual.slides[this.swiper.activeIndex]

      for (var key in this.$refs) {
        if (Object.prototype.hasOwnProperty.call(this.$refs, key)) {
          let ref = this.$refs[key][0]
          if (ref.$vnode.data.key === this.swiper.activeIndex) {
            return ref
          }
        }
      }
    },
    getNextSlideRef () {
      if (this.getPageFromSlideIndex(this.swiper.activeIndex + 1) === undefined) { return }
      for (var key in this.$refs) {
        if (Object.prototype.hasOwnProperty.call(this.$refs, key)) {
          let ref = this.$refs[key][0]
          if (ref.$vnode.data.key === this.swiper.activeIndex + 1) {
            return ref
          }
        }
      }
    },
    getPrevSlideRef () {
      if (this.getPageFromSlideIndex(this.swiper.activeIndex - 1) === undefined) { return }
      for (var key in this.$refs) {
        if (Object.prototype.hasOwnProperty.call(this.$refs, key)) {
          let ref = this.$refs[key][0]
          if (ref.$vnode.data.key === this.swiper.activeIndex - 1) {
            return ref
          }
        }
      }
    },
    insertInterstitials () {
      if (this.interstitials === undefined) {
        return
      }

      // TEST
      // var interstitial1 = this.interstitials[0]
      // var interstitial2 = this.interstitials[1]

      var sectionForFirstpage = this.currentPage.firstPage.sections[0]
      var sectionForSecondPage = null
      if (this.currentPage.secondPage !== null) {
        sectionForSecondPage = this.currentPage.secondPage.sections[0]
      }

      // interstitial1 will be inserted on previous page
      var interstitial1 = this.interstitials[0].leftInterstitial
      // interstitial1 will be inserted on next page
      var interstitial2 = this.interstitials[0].rightInterstitial

      // If one of the pages showing belongs to a section.
      if (sectionForFirstpage !== null || sectionForSecondPage !== null) {
        for (var i = 0; i < this.interstitials.length; i++) {
          var interstitial = this.interstitials[i]
          // If first page belongs to a section.
          if (sectionForFirstpage !== null) {
            if (interstitial.section.id === sectionForFirstpage.id) {
              // We found an interstitial with matching section.
              if (sectionForSecondPage === null) {
                // Second page does not belong to a section or only one page is visible.
                // Set the two interstitials to show.
                interstitial1 = interstitial.leftInterstitial
                interstitial2 = interstitial.rightInterstitial
              } else {
                // Second page belongs to a section.
                // Only set the previous interstitial.
                interstitial1 = interstitial.leftInterstitial
              }
            }
          }
          if (sectionForSecondPage !== null) {
            // Second page belongs to a section.
            if (interstitial.section.id === sectionForSecondPage.id) {
              // We found an interstitial with matching section.
              // Set the next interstitial
              interstitial2 = interstitial.rightInterstitial
            }
          }
        }
      }

      const pagesLength = this.pages.length
      let newPagesArray = this.cleanUpInterstitials()
      const pageIndex = newPagesArray.indexOf(this.currentPage)

      if (pageIndex > 0) {
        newPagesArray.splice(pageIndex, 0, interstitial1)
      }

      if (pageIndex < pagesLength - 1) {
        const atPageIndex = pageIndex === 0 ? pageIndex + 1 : pageIndex + 2
        newPagesArray.splice(atPageIndex, 0, interstitial2)
      }

      this.swipeCounter = 1
      this.$store.commit('setPages', newPagesArray)
    },
    insertInterstitialAdPlaceholder (event) {
      const insertBeforePage = event.detail.insertBeforePage
      const insertAfterPage = event.detail.insertAfterPage

      if (!insertBeforePage && !insertAfterPage) {
        this.cleanUpInterstitialsAndUpdate()
        return
      }

      const pagesLength = this.pages.length
      let newPagesArray = this.cleanUpInterstitials()
      const pageIndex = newPagesArray.indexOf(this.currentPage)

      if (insertBeforePage && pageIndex > 0) {
        const prevPagePlaceholder = CciDataSourceCreateDummyPage(this.currentPage.firstPage, 'prev')
        newPagesArray.splice(pageIndex, 0, prevPagePlaceholder)
      }

      if (insertAfterPage && pageIndex < pagesLength - 1) {
        const page = this.currentPage.secondPage !== null ? this.currentPage.secondPage : this.currentPage.firstPage
        const nextPagePlaceholder = CciDataSourceCreateDummyPage(page, 'next')
        const atPageIndex = pageIndex === 0 || !insertBeforePage ? pageIndex + 1 : pageIndex + 2
        newPagesArray.splice(atPageIndex, 0, nextPagePlaceholder)
      }

      this.swipeCounter = 1
      this.$store.commit('setPages', newPagesArray)
    },
    cleanUpInterstitialsAndUpdate () {
      const newPagesArray = this.cleanUpInterstitials()

      if (newPagesArray.length === this.pages.length) {
        // nothing is removed - nothing to update.
        return false
      }

      this.$store.commit('setPages', newPagesArray)
      return true
    },
    cleanUpInterstitials () {
      const newPagesArray = this.pages.filter(function(value){
        return !value.firstPage.isInterstitial && !value.firstPage.isInterstitialAdPlaceholder
      })
      return newPagesArray
    },
    setPagesContainerLayout () {
      if (this.settings === undefined) {
        return
      }
      const pagesContainer = document.getElementById('pages-container')
      const prevPageBut = document.getElementById('prev-page-button')
      const nextPageBut = document.getElementById('next-page-button')
      if (this.settings.enableVerticalLayout) {
        // TODO: support for ads + vertical layout.
        prevPageBut.style.top = 'calc(50%)'
        nextPageBut.style.top = 'calc(50%)'
        if (!this.isPhone() && !this.isTabletPortrait()) {
          // make space for right aligned menu
          pagesContainer.style.marginRight = '50px'
          nextPageBut.style.right = '80px'
          // make space for left aligned scrubbber
          // const scrollBarWidth = document.getElementById('left-scrubber-container').offsetWidth - document.getElementById('left-scrubber-container').clientWidth
          const scrollBarWidth = this.getScrollBarWidth()
          // 188 is the height of a page thumnail img in the left aligned scrubber. 50 is the left+right padding of the img.
          const leftScrubberWidth = this.getWidthOfWidestPage(this.singlePagesNoAds, 188) + 50 + scrollBarWidth
          pagesContainer.style.marginLeft = leftScrubberWidth + 'px'
          prevPageBut.style.left = leftScrubberWidth + 30 + 'px'
        }
      } else if (this.adsEnabled) {
        var gptInt = document.getElementsByClassName('google-ad-interstitial')[0]
        if (!this.isDesktop()) {
          pagesContainer.style.marginLeft = '0px'
          // move the navigation button and interstitial ad up a bit if there is a bottom ad.
          prevPageBut.style.top = 'calc(50% + 19px)'
          nextPageBut.style.top = 'calc(50% + 19px)'
          gptInt.style.top = 'calc(50% + 19px)'
          if (document.documentElement.clientWidth < 480) {
            prevPageBut.style.left = '10px'
          } else {
            prevPageBut.style.left = '30px'
          }
        } else {
          pagesContainer.style.marginLeft = '300px'
          prevPageBut.style.left = '330px'
        }
      } else {
        prevPageBut.style.top = 'calc(50% + 44px)'
        nextPageBut.style.top = 'calc(50% + 44px)'
      }

      if (!this.settings.enableVerticalLayout || this.isPhone() || this.isTabletPortrait()) {
        if (document.documentElement.clientWidth < 480) {
          prevPageBut.style.left = '10px'
        } else {
          prevPageBut.style.left = '30px'
        }
      }
    },
    fullscreenChange () {
      const prevPageBut = document.getElementById('prev-page-button')
      const nextPageBut = document.getElementById('next-page-button')
      if (document.fullscreenElement) {
        prevPageBut.classList.add('page-prev-white')
        nextPageBut.classList.add('page-next-white')
      } else {
        prevPageBut.classList.remove('page-prev-white')
        nextPageBut.classList.remove('page-next-white')
      }

      this.updateSizeOfPagesContainer()
    },
    createVirtualPageSlides () {
      // this will immidiatly create the CciPageSlide components. We don't want to that before the pages array has content.
      if (this.pages.length === 0) { return [] }
      var virtualSlidesData = []
      for (var i = 0; i < 500; i++) {
        virtualSlidesData.push(i)
      }
      return virtualSlidesData
    },
    toggleLeftScrubber () {
      this.$store.commit('setShowLeftAlignedScrubber', !this.$store.state.showLeftAlignedScrubber)
    },
    wantInterstitialAd (page) {
      const firstPageNum = page.firstPage.pageNumber
      let pageNums = firstPageNum.indexOf('-') !== -1 ? [firstPageNum.split('-')[0], firstPageNum.split('-')[1]] : [firstPageNum]
      if (page.secondPage !== null) {
        pageNums.push(page.secondPage.pageNumber)
      }

      let prePageNums = []
      if (this.pages.indexOf(page) > 0) {
        let prevPage = this.pages[this.pages.indexOf(page) - 1]
        if (prevPage.firstPage.isInterstitialAdPlaceholder) {
          prevPage = this.pages[this.pages.indexOf(page) - 2]
        }
        
        const firstPrevPageNum = prevPage.firstPage.pageNumber
        prePageNums = firstPrevPageNum.indexOf('-') !== -1 ? [firstPrevPageNum.split('-')[0], firstPrevPageNum.split('-')[1]] : [firstPrevPageNum]
        if (prevPage.secondPage !== null) {
          prePageNums.push(prevPage.secondPage.pageNumber)
        }
      }
      let detail = {
        swipeCount: this.swipeCounter,
        curPageNos: pageNums,
        prevPageNos: prePageNums,
        pageGroup: page.firstPage.sections.length > 0 ? page.firstPage.sections[0].name : ''
      }      

      const pubPath = this.opsUrl.split('issues')[0]
      detail.interstitialInfoURL = pubPath + 'interstitialInfo'
      const event = new CustomEvent('wantInterstitialAd', { detail: detail })
      window.dispatchEvent(event)
    },
    setSlidesPageIndexes (pages, currentPageIndex, currentSlideIndex) {
      let newSlidePageIndexes = []
      for (var i = 0; i < pages.length; i++) {
        const slideIndex = currentSlideIndex - currentPageIndex + i
        newSlidePageIndexes.push(slideIndex)
      }

      this.$store.commit('setSlidesPageIndexes', newSlidePageIndexes)
    },
    getSlideIndexFromPageIndex (pageIndex) {
      return this.slidesPageIndexes[pageIndex]
    },
    getPageIndexFromActiveSlideIndex () {
      for (var i = 0; i < this.slidesPageIndexes.length; i++) {
        if (this.slidesPageIndexes[i] === this.swiper.activeIndex) {
          return i
        }
      }
    },
    getPageFromActiveSlideIndex () {
      for (var i = 0; i < this.slidesPageIndexes.length; i++) {
        if (this.slidesPageIndexes[i] === this.swiper.activeIndex) {
          return this.pages[i]
        }
      }
    },
    getPageFromSlideIndex (index) {
      for (var i = 0; i < this.slidesPageIndexes.length; i++) {
        if (this.slidesPageIndexes[i] === index) {
          return this.pages[i]
        }
      }
    }
  },
  beforeDestroy () {
    // window.removeEventListener('resize', this.didResize)
    if (this.resizeObserver !== null) {
      this.resizeObserver.unobserve(this.$refs['pages-container'])
    }

    window.removeEventListener('orientationchange', this.orientationDidChange)

    document.removeEventListener('keydown', this.checkKeyDown)
    document.removeEventListener('fullscreenchange', this.fullscreenChange)
    document.removeEventListener('mozfullscreenchange', this.fullscreenChange)
    document.removeEventListener('webkitfullscreenchange', this.fullscreenChange)
    document.removeEventListener('msfullscreenchange', this.fullscreenChange)

    window.removeEventListener('prepareInterstitialAd', this.insertInterstitialAdPlaceholder)

    if (this.swiper !== null) {
      this.swiper.destroy()
      this.swiper = null
    }
  },
  components: {
    CciPageSlide
  }
}
